import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../services/util.service';
import { ConstantesService } from '../../services/constantes.service';
import * as moment from 'moment';

@Component({
  selector: 'fd-datepicker-range',
  templateUrl: './fd-datepicker.component.html',
  styleUrls: ['./fd-datepicker.component.scss']
})
export class FdDatepickerRangeComponent implements OnChanges {


  @Input() error: boolean;
  @Input() range: boolean;
  @Input() minDate: NgbDate;
  @Input() maxDate: NgbDate;
  @Input() fromDate: NgbDate;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() pantallaOrigen: string;
  @Output() fecha = new EventEmitter();


  public hoveredDate: NgbDate;
  public arrows = 'select';
  public toDate: NgbDate = null;
  public model;
  public open = false;
  public today = this.calendar.getToday();
  public fechaActual: any;
  public fechaminima: any;
  public rangeOption = true;


  constructor(private calendar: NgbCalendar, private utilService: UtilService) { }


  ngOnChanges(changes: SimpleChanges) {

    if (changes) {
      if (changes.fromDate
        && changes.fromDate.currentValue !== changes.fromDate.previousValue
        && changes.fromDate.currentValue) {
        if (typeof changes.fromDate.currentValue === 'string') {
          this.fromDate = this.utilService.toStruct(changes.fromDate.currentValue);
        } else {
          this.fromDate = changes.fromDate.currentValue;
        }
        this.model = this.fromDate.day.toString() + '/' + this.fromDate.month.toString() + '/' + this.fromDate.year.toString();
      }

      if (changes.maxDate
        && changes.maxDate.currentValue !== changes.maxDate.previousValue
        && changes.maxDate.currentValue) {
        if (typeof changes.maxDate.currentValue === 'string') {
          this.maxDate = this.utilService.toStruct(changes.maxDate.currentValue);
        } else {
          this.maxDate = changes.maxDate.currentValue;
        }
      }

      if (changes.minDate
        && changes.minDate.currentValue !== changes.minDate.previousValue
        && changes.minDate.currentValue) {
        if (typeof changes.minDate.currentValue === 'string') {
          this.minDate = this.utilService.toStruct(changes.minDate.currentValue);
        } else {
          this.minDate = changes.minDate.currentValue;
        }
      }
    }

    if (!this.fromDate && !this.placeholder) {
      this.obtenerFechaActual();
    }

  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.fecha.emit({ fecha: date, fechaInicio: date, fechaFin: null });
      this.model = this.fromDate.day.toString() + '/' + this.fromDate.month.toString() + '/' + this.fromDate.year.toString();
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.fecha.emit({ fecha: this.fromDate, fechaInicio: this.fromDate, fechaFin: this.toDate });
      this.model =
        this.fromDate.day.toString() + '/'
        + this.fromDate.month.toString() + '/'
        + this.fromDate.year.toString() + ' - '
        + this.toDate.day.toString() + '/'
        + this.toDate.month.toString() + '/'
        + this.toDate.year.toString();
    } else {
      this.toDate = null;
      this.fromDate = date;
      this.fecha.emit({ fecha: this.fromDate, fechaInicio: this.fromDate, fechaFin: this.toDate });
      this.model =
        this.fromDate.day.toString() + '/'
        + this.fromDate.month.toString() + '/'
        + this.fromDate.year.toString();
    }

    if (!this.range) {
      this.openCalendar();
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  openCalendar() {
    this.open = !this.open;
  }

  obtenerFechaActual() {
    const fechaActual = new Date();
    const diaTemp = fechaActual.getDate().toString();
    const mes = ConstantesService.MESES[fechaActual.getMonth()];
    const dia = ConstantesService.DIAS_SEMANA[fechaActual.getDay()];
    this.fechaActual = dia + ', ' + diaTemp + ' ' + mes;

    this.fromDate = this.utilService.toStruct(fechaActual);
    this.fromDate.day = fechaActual.getDate();
    this.fromDate.month = fechaActual.getMonth() + 1;
    this.fromDate.year = fechaActual.getFullYear();

    this.model = this.fromDate.day.toString() + '/' + this.fromDate.month.toString() + '/' + this.fromDate.year.toString();

  }
}
